module.exports = __webpack_public_path__ + "img/03-info-03-m.1822420d.png";